import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useAuth } from './AuthContext';
import { SEEDF_COURSE_ID } from '../content/seedf/officialProgram2022';
import { loadSharedUnits } from '../services/integratedStudyService';
const Context=createContext({ units:[], error:'', resolve:lesson=>lesson });
export const useSharedTheory=()=>useContext(Context);
export function SharedTheoryProvider({ children }) {
  const { usuario, canAccessCourse, perfil }=useAuth();
  const [remote,setRemote]=useState([]),[error,setError]=useState('');
  const key=['inss',SEEDF_COURSE_ID].filter(id=>canAccessCourse(id)).join(',');
  useEffect(()=>{
    let active=true;setRemote([]);setError('');
    if(usuario && key) loadSharedUnits(key.split(',')).then(items=>{if(active)setRemote(items);}).catch(()=>{if(active)setError('Não foi possível sincronizar a teoria compartilhada. Tente novamente antes de concluir o estudo.');});
    return()=>{active=false;};
  },[usuario?.uid,key,perfil?.role]);
  const units=useMemo(()=>remote,[remote]);
  const resolve=lesson=>{
    const unit=units.find(u=>u.id===lesson?.theoryId);
    return unit?{...lesson,...unit,id:lesson.id,courseId:lesson.courseId,subjectId:lesson.subjectId,moduleId:lesson.moduleId,
      theoryId:unit.id,theoryVersion:unit.version,noticeTopicIds:lesson.noticeTopicIds,lessonNumber:lesson.lessonNumber,
      examTips:unit.traps,questionIds:lesson.questionIds,mindMap:{title:unit.title,branches:unit.map}}:lesson;
  };
  return <Context.Provider value={{units,error,resolve}}>{children}</Context.Provider>;
}
